export function formatWhen(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export const WRITER_TYPES = [
  { value: '', label: 'Not set' },
  { value: 'novelist', label: 'Novelist' },
  { value: 'series', label: 'Series' },
  { value: 'screen', label: 'Screen' },
  { value: 'other', label: 'Other' },
];

export const ONBOARDING_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'key_ready', label: 'Key ready' },
  { value: 'first_project', label: 'First project' },
  { value: 'first_draft', label: 'First draft' },
  { value: 'active', label: 'Active' },
];

export const LEAD_STATUSES = [
  { value: 'waitlist', label: 'Waitlist' },
  { value: 'invited', label: 'Invited' },
  { value: 'converted', label: 'Converted' },
];

export function labelFor(options, value) {
  const match = options.find((option) => option.value === value);
  return match ? match.label : (value || '—');
}
